import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-scroll";
import './Navbar.css';
import logo from '../../Images/dhanushdhari_final_log.jpeg'; // Ensure this path is correct
import { useNavigate } from 'react-router-dom';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Change navbar background on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Features", to: "features" },
    { name: "About Us", to: "about" }, // Linked to your About section
    { name: "Practice Areas", to: "practice-areas" },
    { name: "FAQ", to: "faq" },
  ];

  return (
    <header className={`legal-nav-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="legal-nav-container">
        <img src={logo} alt="Dhanushdhari Logo" className="legal-nav-logo" width="60" height="60" style={{borderRadius:"100%"}} onClick={()=>navigate("/")}/>
        {/* <motion.div 
          className="legal-nav-logo"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
        >
          DHANUSHDHARI
        </motion.div> */}

        {/* Desktop Navigation */}
        <nav className="legal-nav-links">
          {navLinks.map((link) => (
            <Link 
              key={link.to}
              to={link.to} 
              smooth={true} 
              duration={600} 
              offset={-80}
              className="legal-nav-item"
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Action Button */}
        <div className="legal-nav-actions">
          <button className="legal-nav-btn" onClick={()=>navigate("/consultation")}>Get Started</button>
          
          {/* Mobile Toggle */}
          <div 
            className={`legal-nav-toggle ${isMobileMenuOpen ? 'open' : ''}`} 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div 
            className="legal-nav-mobile-overlay"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            {navLinks.map((link) => (
              <Link 
                key={link.to}
                to={link.to} 
                smooth={true} 
                onClick={() => setIsMobileMenuOpen(false)}
                className="legal-nav-mobile-item"
              >
                {link.name}
              </Link>
            ))}
            <button className="legal-nav-btn mobile">Get Started</button>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}

export default Navbar;